import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { VonageForm, VonageIFrame } from './CardPaymentPopup.styles';

const VonageFrame = ({ iframeURL, accessToken, refreshToken }) => {
  const formRef = useRef();
  useEffect(() => {
    formRef.current.submit();
  }, [formRef]);

  return (
    <>
      <VonageIFrame name="vonage-client" />
      <VonageForm ref={formRef} action={iframeURL} id="initForm" target="vonage-client" method="POST">
        <input name="X-BEARER-TOKEN" readOnly value={accessToken} />
        <input name="X-REFRESH-TOKEN" readOnly value={refreshToken} />
      </VonageForm>
    </>
  );
};

VonageFrame.propTypes = {
  iframeURL: PropTypes.string.isRequired,
  accessToken: PropTypes.string.isRequired,
  refreshToken: PropTypes.string.isRequired
};

export default VonageFrame;
